import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { StringHelper } from '../../shared/string-helper';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly stringHelper: StringHelper
  ) {}

  /**
   * Get the current route url and params to be used as a back route in the navigation extras state
   * @returns NavigationExtras
   * @example
   * State: {back: { url: string, params: any}}
   */
  public getBackRouteState(): NavigationExtras {
    const queryParamsMap = this.route.snapshot.queryParamMap;
    const queryParams = {};
    for (const key of queryParamsMap.keys) {
      queryParams[key] = queryParamsMap.get(key);
    }

    const navigationExtras: NavigationExtras = {
      state: { back: { url: this.router.url.split('?')[0], params: queryParams } },
    };

    return navigationExtras;
  }

  /**
   * Uppercase the first letter of a string
   * @param str
   * @returns string
   */
  public uppercaseFirstLetter(str: string): string {
    return this.stringHelper.uppercaseFirstLetter(str);
  }

  /**
   * Uppercase first letter of each word in a string
   * @param str
   * @returns
   */
  public uppercaseWords(str: string): string {
    return this.stringHelper.uppercaseWords(str);
  }

  /**
   * Checks if a string is null, undefined or empty
   * @param str
   * @returns
   */
  public isNullOrEmpty(str: string): boolean {
    return this.stringHelper.isNullOrEmpty(str);
  }
}
